import { LadiesMain } from "../global/ladies-main"
import { makeSureVueIsLoaded } from "./vue.js"

const ageVerificationModal = $("#age-verification-modal")

ageVerificationModal.on("show.bs.modal", async (e) => {
    await makeSureVueIsLoaded()
    let triggeredByStarsSubscription = false
    if (e.relatedTarget?.dataset.content) {
        const successModal = e.relatedTarget.dataset.content.slice(1)
        if (successModal) {
            LadiesMain.addHashtagToUrl("success-modal", successModal)

            if (["subscriptionModal_48hours", "subscriptionModal_1month"].indexOf(successModal) > -1) {
                triggeredByStarsSubscription = true
            }
        }
    } else {
        if (
            e.relatedTarget instanceof HTMLButtonElement &&
            !e.relatedTarget.classList.contains("dont-show-buy-button-modal")
        ) {
            if (e.relatedTarget.dataset.price) {
                const postId = e.relatedTarget.closest(".lavert-card").id.slice(5)
                const forFansOnly = e.relatedTarget.classList.contains("priceForFan")

                LadiesMain.addHashtagToUrl("exclusive-post-purchase-button", postId)
                LadiesMain.addHashtagToUrl("for-fans-only", JSON.stringify(forFansOnly))
            } else {
                LadiesMain.addHashtagToUrl("subscription-modal-buy-buttons")
                triggeredByStarsSubscription = true
            }
        }
    }

    if (typeof window.sharedComponentsLoaded === "undefined") {
        // modal is opened for the first time
        // load css
        const fileRef = document.createElement("link")
        fileRef.setAttribute("rel", "stylesheet")
        fileRef.setAttribute("type", "text/css")
        fileRef.setAttribute(
            "href",
            `https://static.ladies-cdn.de/ladies/shared/${SiteInfo.vueComponentVersion}/lib/vue-components.css`,
        )
        document.head.appendChild(fileRef)
        // load js
        const script = document.createElement("script")
        script.onload = () => {
            mountAgeVerification(triggeredByStarsSubscription)
            toggleAgeVerificationStarsContentVersion(e)
        }
        script.src = `https://static.ladies-cdn.de/ladies/shared/${SiteInfo.vueComponentVersion}/lib/vue-components.umd.min.js`
        document.head.appendChild(script)
        window.sharedComponentsLoaded = true
    } else if (typeof window.sharedAgeVerificationMounted === "undefined") {
        mountAgeVerification(triggeredByStarsSubscription)
        toggleAgeVerificationStarsContentVersion(e)
    }

    LadiesMain.addHashtagToUrl("age-verification-modal")
})

ageVerificationModal.on("hide.bs.modal", () => {
    LadiesMain.removeHashtagFromUrl("age-verification-modal")
    LadiesMain.removeHashtagFromUrl("success-modal")
    LadiesMain.removeHashtagFromUrl("subscription-modal-buy-buttons")
})

$(document).ready(() => {
    if (LadiesMain.checkHashtagInUrl("age-verification-modal")) {
        if (userData.isAgeVerified) {
            LadiesMain.removeHashtagFromUrl("age-verification-modal")
            closeAgeVerificationModal()
            openSuccessModalIfSet()
            openSubscriptionModalBuyButtonsIfSet()
            openPostBuyModalIfSet().then()
        } else {
            ageVerificationModal.modal("show")
        }
    }
})

window.redirectWithCorrectReferrer = (args) => {
    const isLoggedIn = userData.isLoggedIn
    if (!isLoggedIn && args && args.reLogin) {
        // no reLogin if not loggedIn already
        return
    }
    window.location.href = `/login?ref=${encodeURIComponent(window.location.pathname + window.location.hash)}`
}

window.mountAgeVerification = (triggeredByStarsSubscription) => {
    const baseURL = SiteInfo.loginUrl
    const IDEJAL_PAYMENT_URL = SiteInfo.paymentUrl
    const BACKEND_SHOP_URL = SiteInfo.paymentBackendShopUrl
    const headers = {
        Authorization: `Bearer ${SiteInfo.accessToken}`,
        Accept: "application/json",
    }
    const store = {
        ladies: {},
    }

    if (triggeredByStarsSubscription) {
        store.ladies.modalContext = "stars"
    } else {
        store.ladies.modalContext = ""
    }

    Vue.use(window["vue-components"].default, { headers, baseURL, IDEJAL_PAYMENT_URL, BACKEND_SHOP_URL })
    Vue.prototype.extendStore(store)
    new Vue({
        data: {
            store,
        },
        mounted() {
            this.$config.DASHBOARD_URL = SiteInfo.loginDashboardUrl
            this.$config.IDEJAL_ORDER_BACKEND_URL = SiteInfo.paymentOrderBackendUrl
            this.$config.PAYMENT_MAINTENANCE = SiteInfo.paymentMaintenance
            this.$config.BACKEND_SHOP_URL = SiteInfo.paymentBackendShopUrl
        },
    }).$mount("#age-verification-app")

    const avsModalElement = ageVerificationModal.get(0)

    elementData.set(avsModalElement, {
        ...elementData.get(avsModalElement),
        ...{ vueStore: store },
    })

    window.sharedAgeVerificationMounted = true
}

window.closeAgeVerificationModal = () => {
    ageVerificationModal.modal("hide")
}

window.openSuccessModalIfSet = () => {
    if (LadiesMain.checkHashtagInUrl("success-modal")) {
        const successModal = LadiesMain._getHashtagObject()["success-modal"]
        LadiesMain.removeHashtagFromUrl("success-modal")
        const subscriptionButton = document.querySelector(`[data-content="#${successModal}"]`)
        if (subscriptionButton) {
            subscriptionButton.setAttribute("data-target", "#subscriptionModal")
            subscriptionButton.click()
        }
    }
}

window.openSubscriptionModalBuyButtonsIfSet = () => {
    if (LadiesMain.checkHashtagInUrl("subscription-modal-buy-buttons")) {
        LadiesMain.removeHashtagFromUrl("subscription-modal-buy-buttons")
        const subscriptionModalBuyButtons = document.querySelector("#become-a-fan")
        if (subscriptionModalBuyButtons) {
            subscriptionModalBuyButtons.click()
        }
    }
}

window.successfulAgeVerificationModal = () => {
    closeAgeVerificationModal()
    openSuccessModalIfSet()
}

window.toggleAgeVerificationStarsContentVersion = (/** jQuery.Event */ modalEvent) /** void */ => {
    const modalContainer = modalEvent.target

    if (!elementData.has(modalContainer)) {
        return
    }

    const modalData = elementData.get(modalContainer)

    if (!("vueStore" in modalData)) {
        return
    }

    const modalTrigger = modalEvent.relatedTarget
    const modalTriggerIsStarsContent = modalTrigger && modalTrigger.closest(".ladiesplus") !== null
    const isStarsEventPage = window.location.pathname.startsWith("/stars/aktion")

    if (modalTriggerIsStarsContent || isStarsEventPage) {
        modalData.vueStore.ladies.modalContext = "stars"
    } else {
        modalData.vueStore.ladies.modalContext = ""
    }
}

async function openPostBuyModalIfSet() {
    if (
        LadiesMain.checkHashtagInUrl("exclusive-post-purchase-button") &&
        LadiesMain.checkHashtagInUrl("for-fans-only")
    ) {
        const postId = LadiesMain._getHashtagObject()["exclusive-post-purchase-button"]
        const forFansOnly = LadiesMain._getHashtagObject()["for-fans-only"] === "true"
        const starsPostContainer = document.getElementById("stars-post-container")

        LadiesMain.removeHashtagFromUrl("exclusive-post-purchase-button")
        LadiesMain.removeHashtagFromUrl("for-fans-only")

        await waitForChildWithClass(starsPostContainer, "stars-post")

        let post = document.getElementById("post-" + postId)

        if (post === null) {
            let postIsVisible = false

            while (!postIsVisible) {
                const morePostsButton = document.getElementById("load-posts-btn")
                morePostsButton.click()
                await waitUntilButtonNotLoading(morePostsButton)
                post = document.querySelector('div[id="post-' + postId + '"]')

                if (post instanceof HTMLElement) {
                    postIsVisible = true
                }

                if (document.querySelector(".no-further-posts")) {
                    break
                }
            }
        }

        setTimeout(() => {
            requestAnimationFrame(() => post.scrollIntoView())
        }, 0)

        const postButtonClass = forFansOnly ? "priceForFan" : "priceForUser"

        let postButtonToClick = post.querySelector("." + postButtonClass)

        if (!postButtonToClick) {
            postButtonToClick = post.querySelector(".priceForFan")
        }

        postButtonToClick?.click()
    }
}

async function waitUntilButtonNotLoading(button) {
    return new Promise((resolve) => {
        const observer = new MutationObserver(() => {
            const text = button.textContent.trim()

            if (text !== "Lädt...") {
                observer.disconnect()
                resolve()
            }
        })

        observer.observe(button, {
            childList: true,
            characterData: true,
            subtree: true,
        })
    })
}

async function waitForChildWithClass(parent, className) {
    return new Promise((resolve) => {
        // Falls das Element schon existiert, sofort zurückgeben
        const existing = parent.querySelector(`.${className}`)
        if (existing) return resolve(existing)

        const observer = new MutationObserver((mutations, obs) => {
            const child = parent.querySelector(`.${className}`)
            if (child) {
                obs.disconnect() // Observer stoppen
                resolve(child) // Gefundenes Element zurückgeben
            }
        })

        observer.observe(parent, {
            childList: true, // Änderungen an direkten Kindern beobachten
            subtree: true, // auch alle Unterelemente beobachten
        })
    })
}
